import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { useridSelector } from '../../features/user/UserSlice';
import { changeDevice } from '../../features/fueladmin/fuelSlice';
import { FormControl, InputAdornment, TextField, Button, Typography } from '@mui/material';
import { CircularProgress } from '@mui/material';



const FuelDeviceChange = ({ view, fuelSetup, assetId }) => {
    const dispatch = useDispatch();
    const userid = useSelector(useridSelector);
    const [newImei, setNewImei] = useState("");
    const [loading, setloading] = useState(false);

    const saveSetup = () => {
        setloading(true);
        dispatch(changeDevice({ assetId: newImei, oldImei: assetId, userid }));
    }

    if (loading) {
        return (
            <div>
                <FormControl sx={{ m: 1, width: '100ch' }} >
                    <CircularProgress />
                </FormControl>
            </div>
        );
    } else {
        return (
            <div>
                <FormControl sx={{ m: 1, width: '100ch' }} >
                    <Typography variant="body1" display="inline">
                        <span><b>New Device IMEI</b></span>
                    </Typography>
                </FormControl>
                <FormControl sx={{ m: 1, width: '80ch' }} >
                    <TextField
                        label="Sensor Serial Number?"
                        id="sensorSerial"
                        value={newImei}
                        onChange={(e) => setNewImei(e.target.value)}
                        sx={{ m: 1, width: '70ch' }}
                        InputProps={{
                            startAdornment: <InputAdornment position="start">Imei: </InputAdornment>,
                        }}
                        variant="standard"
                    />
                </FormControl>
                <FormControl sx={{ m: 1, width: '30ch' }} >
                    <Button onClick={() => saveSetup()} disabled={newImei.length !== 15}>
                        Commit Change
                    </Button>
                </FormControl>
            </div>
        )
    }
}

export default FuelDeviceChange;